import {
  DeesElement,
  property,
  html,
  customElement,
  TemplateResult,
  css,
  cssManager,
} from '@designestate/dees-element';

import * as domtools from '@designestate/dees-domtools';
import '@uptimelink/webwidget';

declare global {
  interface HTMLElementTagNameMap {
    'lele-header': LeleHeader;
  }
}

@customElement('lele-header')
export class LeleHeader extends DeesElement {
  public static demo = () => html`<lele-header></lele-header>`;

  @property()
  public slogan = 'Open Source and Open Core for Enterprises';

  public menuItems: { name: string; action: () => void }[] = [
    {
      name: 'Link 1',
      action: () => {},
    },
    {
      name: 'Link 2',
      action: () => {},
    },
  ];

  constructor() {
    super();
    domtools.elementBasic.setup();
  }

  public static styles = [
    cssManager.defaultStyles,
    css`
      :host {
        user-select: none;
        display: block;
      }

      :host([hidden]) {
        display: none;
      }

      .headerMain {
        background: ${cssManager.bdTheme('#eeeeeb', '#000000')};
        color: ${cssManager.bdTheme('#000000', '#ffffff')};
        position: relative;
        padding-bottom: 30px;
        z-index: 1;
      }

      .navigation {
        max-width: var(--lelecv-pagewidth, 1200px);
        margin: auto;
        padding-top: 50px;
        border-bottom: 1px solid var(--lelecv-color-accent, #e4002b);
        display: grid;
        grid-template-columns: 130px auto;
      }

      .logo {
        height: 35px;
        width: 130px;
        object-fit: contain;
        margin-bottom: 20px;
      }

      .logo img {
        user-drag: none;
        -webkit-user-drag: none;
        filter: ${cssManager.bdTheme('invert(1)', '')};
      }

      .navlinks {
        display: grid;
        grid-template-columns: auto min-content min-content min-content min-content min-content;
        text-transform: uppercase;
      }

      .navigation .mobile {
        display: none;
        margin-top: -15px;
      }

      ${cssManager.cssForTablet(`
        
          .navigation {
            margin-left: 40px;
            margin-right: 40px;
          }
        
        `)}
      ${cssManager.cssForPhablet(`
          .navigation {
            margin-left: 30px;
            margin-right: 30px;
          }
        `)}
          ${cssManager.cssForPhone(`
            .navigation .mobile {
              display: block;
            }

            .navigation .desktop {
              display: none;
            }
        `)}

      .link {
        cursor: pointer;
        padding-top: 20px;
        padding-left: 20px;
      }

      .link:active {
        color: #999999;
      }

      .link.desktop {
        white-space: nowrap;
      }

      .link a {
        color: #fff;
        text-decoration: none;
      }
      .slogan {
        font-size: 40px;
        padding-right: 40px;
        padding-left: 40px;
        max-width: var(--lelecv-pagewidth);
        margin: auto;
        margin-top: 50px;
        margin-bottom: 30px;
        text-align: center;
        font-weight: 100;
      }

      uptimelink-webwidget {
        display: block;
        padding-bottom: 40px;
      }
    `,
  ];

  public render(): TemplateResult {
    return html`
      <div class="headerMain">
        <div class="navigation">
          <div class="logo">
            <img
              src="https://assetbroker.lossless.one/brandfiles/lossless/svg-minimal-bright.svg"
            />
          </div>
          <div class="navlinks">
            <div class="middlespace"></div>
            ${this.menuItems.map((menuItem) => {
              return html`
                <div
                  class="link desktop"
                  @click="${() => {
                    menuItem.action();
                  }}"
                >
                  ${menuItem.name}
                </div>
              `;
            })}
            <div class="link mobile">mobile navigation</div>
          </div>
        </div>
        <div class="slogan">${this.slogan}</div>
        <uptimelink-webwidget></uptimelink-webwidget>
      </div>
      <slot></slot>
    `;
  }
}
